/* eslint-disable camelcase */
// @TODO - Prevent this from causing loading from showing

window.cb_storeprefonserver = function cb_storeprefonserver(data) {
  window.finishAjaxRequest(data.pannel_id, data);
};

window.storePrefOnServer = function storePrefOnServer(name, pref, value, panelId) {
  const content_map = {} as ContentMap;
  content_map.method = 'POST';
  content_map.form_name = 'setpref';
  content_map.name = name;
  content_map.pref = pref;
  content_map.value = value;
  content_map.pannel_id = panelId;
  window.doServerCall(content_map, window.cb_storeprefonserver);
};
